/** @import { MapLayerDockStore } from './map-layer-dock-state.js' */
/** @import {MapBase} from '../default-map-bases.js' */
import { DEFAULT_CESIUM_MAP_BASES } from '../default-map-bases.js';

export class MapLayerDockService {
  /** @type {MapLayerDockStore} */
  #store;

  /** @type {Function | null} */
  #disconnectMapBaseListener = null;

  constructor(store) {
    this.#store = store;
  }

  /** Detaches all active listeners. */
  disconnectMapLayerDock() {
    this.#disconnectMapBaseListener?.();
  }

  /**
   * Sets up a listener for WMS layers in a user group and stores them in the state.
   * Updates the store each time the data changes.
   * @param {string} userGroup
   */
  setUpMapBasesListener(userGroup) {
    if (!userGroup) throw new Error('An active company is required to listen to map bases.');
    this.#disconnectMapBaseListener?.();

    // Set up the callback for when the map bases change in firebase
    const mapBasesCallback = (snapshot) => {
      const wmsMapBasesObject = snapshot.val() ?? {};
      Object.keys(wmsMapBasesObject).forEach((key) => (wmsMapBasesObject[key].type = 'wms'));
      this.#store.getState().setFirebaseMapBaseConfigs(wmsMapBasesObject);
    };

    // Set up the listener for the WMS map bases
    const wmsMapBasesRef = globalThis.FirebaseWorker.ref(`photoheight/company_space/${userGroup}/wms_layers`);
    wmsMapBasesRef.on('value', mapBasesCallback);

    this.#disconnectMapBaseListener = () => wmsMapBasesRef.off('value', mapBasesCallback);
  }

  /**
   * Validates the map base key and writes it to the store.
   * @param {string} mapBaseKey
   */
  selectMapBase(mapBaseKey) {
    if (!mapBaseKey) throw new Error('Missing data to change map base');

    const firebaseMapBaseConfigs = this.#store.getState().firebaseMapBaseConfigs;
    const mapBaseConfig = firebaseMapBaseConfigs?.[mapBaseKey] ?? DEFAULT_CESIUM_MAP_BASES[mapBaseKey];
    if (!mapBaseConfig) throw new Error('Invalid map base.');

    this.#store.getState().setActiveMapBaseKey(mapBaseKey);
  }
}
